import logo from './logo.svg';
import './App.css';
import LandingPage from './components/LandingPage';
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import Header from './components/Header';
import Snowfall from './components/Snowfall';
import Footer from './components/Footer';
import About1 from './components/About1';
import AboutPage from './components/AboutPage';
import CompanyOverview from './components/CompanyOverview';
import HsePolicy from './components/HsePolicy';
import ForeignPartnerCarousel from './components/ForeignPartnerCarousel';
import ServicesSection from './components/ServicesPage';
import OffsureSurveyPage from './components/OffsureSurveyPage';
import SpecialSurveyPage from './components/SpecialSurveyPage';
import OnshoreSurveyPage from './components/OnshoreSurveyPage';
import EngineeringServicesPage from './components/EngineeringServices';
import NewsPage from './components/NewsPage';
import NigerianContentPolicy from './components/NigerianContent';
import ContactUs from './components/ContactUs';
import ScrollToTop from './components/ScrollToTop';
import OnshoreSurveysArticle from './components/OnshoreSurveysArticle';
import OffshoreSurveysArticle from './components/OffshoreSurveysArticle';
import BathymetricSurveysArticle from './components/BathymetricServices';

function App() {
  return (
<BrowserRouter>
<Snowfall/>
<ScrollToTop/>
<Header/>
<Routes>
  <Route path='/' element={<LandingPage/>}/>
  <Route path='/aboutus' element={<AboutPage/>}/>
  <Route path='/companyoverview' element={<CompanyOverview/>}/>
  <Route path ='/qhse' element={<HsePolicy/>}/>
  <Route path='/partners' element={<ForeignPartnerCarousel/>}/>
  <Route path ='/services' element={<ServicesSection/>}/>
  <Route path ='/offshoresurvey' element={<OffsureSurveyPage/>}/>
  <Route path='/specialsurvey' element={<SpecialSurveyPage/>}/>
  <Route path='/onshoresurvey' element={<OnshoreSurveyPage/>}/>
  <Route path ='/engineeringservices' element={<EngineeringServicesPage/>}/>
  <Route path='/news' element={<NewsPage/>}/>
  <Route path='/nigeriancontent' element={<NigerianContentPolicy/>}/>
  <Route path='/contactus' element={<ContactUs/>}/>
  <Route path='/onshoresurveys' element={<OnshoreSurveysArticle/>}/>
  <Route path='/offshoresurveys' element={<OffshoreSurveysArticle/>}/>
  <Route path='/bathymetricservices' element={<BathymetricSurveysArticle/>}/>
</Routes>
<Footer/>
</BrowserRouter>
  );
}

export default App;
